/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function checkImgExists(imgurl) {
  return new Promise(function (resolve, reject) {
    var ImgObj = new Image();
    ImgObj.src = imgurl;
    ImgObj.onload = function (res) {
      resolve(res);
    }
    ImgObj.onerror = function (err) {
      reject(err);
    }
  })
}

export function leftTrim(str) {
  if (str.charAt(0) == " ") {
    str = str.slice(1);
    str = leftTrim(str);
  }
  return str;
}

export function rightTrim(str) {
  if (str.length - 1 >= 0 && str.charAt(str.length - 1) == " ") {
    str = str.slice(0, str.length - 1);
    str = rightTrim(str);
  }
  return str;
}

export function filterTime(time) {
  var date = new Date(time);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
}

export function onCopy(txt) {
  const oInput = document.createElement('textarea')
  oInput.value = txt
  document.body.appendChild(oInput)
  oInput.select() // 选择对象
  document.execCommand('Copy') // 执行浏览器复制命令
  oInput.remove()
}

export function judgmentValue(value) {
  if (value === undefined || value === null || value === '') {
    return false
  }
  return true
}

export function removeProperty(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] === '' || obj[key] === undefined || obj[key] === null || obj[key] === 'null') delete obj[key]
  })
  return obj
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

// 返回地址下载
export function downloadLink(filePath, filename) {
  let link = document.createElement('a')
  link.href = `${filePath}`
  filename && link.setAttribute('download', filename)
  link.click()
  URL.revokeObjectURL(filePath)
  link.remove()
}

export function loopGetCorpusSentCount(ajax, params, delay = 1500) {
  return new Promise((resolve, reject) => {
    try {
      ajax(params).then(({ result, success }) => {
        if (success) {
          if (result[0].status !== 1) {
            window.setTimeout(() => {
              resolve(loopGetCorpusSentCount(ajax, params, delay))
            }, delay)
          } else {
            resolve(result)
          }
        }
      })
    } catch (error) {
      reject(error)
    }
  })
}
// 轮询
export const polling = (ajax, params, delay = 1000) => {
  return new Promise((resolve, reject) => {
    try {
      ajax(params).then(({ result, success }) => {
        if (success) {
          if (result.percent !== 100) {
            window.setTimeout(() => {
              resolve(polling(ajax, params, delay))
            }, delay)
          } else {
            resolve(result)
          }
        }
      })
    } catch (error) {
      reject(error)
    }
  })
}
// a 链接下载
export const downloadServerFile = (fileName, filePath) => {
  if (fileName && filePath) {
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = `/cat/api/v1/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}